import { Stack, ThemeIcon, Title } from "@mantine/core";
import { useTimeout } from "@mantine/hooks";
import { ContextModalProps } from "@mantine/modals";
import { CalendarCheckIcon } from "@phosphor-icons/react";
import { useNavigate } from "@tanstack/react-router";
import { useLayoutEffect } from "react";

export function SuccessQueueStatusModal({ id, context }: ContextModalProps) {
  const navigate = useNavigate();

  const TIMEOUT = 1000 * 5;
  const { start, clear } = useTimeout(() => {
    context.closeModal(id);
    navigate({ to: "/app/agendamento/status" });
  }, TIMEOUT);

  useLayoutEffect(() => {
    start();
    return clear;
  }, []);

  return (
    <Stack align="center" justify="center" gap={0}>
      <ThemeIcon size="256" color="white" variant="transparent">
        <CalendarCheckIcon weight="bold" size={256} />
      </ThemeIcon>

      <Title order={1} c="white" ta="center">
        Agendamento <br />
        Confirmado
      </Title>
    </Stack>
  );
}
